import React, { useRef, useState, useEffect } from "react";
import SelectInput from "../../../components/SelectInput";
import TextInput from "../../../components/TextInput";
import PlusButton from "../../../components/PlusButton";
import MinusButton from "../../../components/MinusButton";
import ProdCodeFormProducerCodeSection from "./ProdCodeFormProducerCodeSection";
import MaterialSubTable from "../../../components/tables/MaterialSubTable";
import useGetEmployees from "./hooks/useGetEmployees";
import useGetAllFranchiseEmployees from "../../CarrierAgreementMgmt/Employees/Confie/hooks/useGetAllFranchiseEmployees";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import { useRecoilState, useRecoilValue } from "recoil";
import ConfirmBoxModal from "../../../components/ConfirmBoxModal";
import ReactTooltip from "react-tooltip";
import {
  prodAddState,
  prodCodeIsFranchise,
  prodCodeMastercarrierId,
  carrierNameValue,
} from "./atoms/atoms";
import { useFranchiseEmployee } from "../Employees/Franchise/hooks/UseFranchiseEmployee";
const ProdCodeFormCarrierSection = ({
  data,
  tableName,
  handleRemovecarrierAddress,
  carriers,
  agencies,
  handleAddcarrierProducerCodeRow,
  carrierProducerCodeData = [],
  handleContactInputs,
  handleAddProducerCodeRow,
  handleRemoveProducerCodeRow,
  handleProducerCodeInputs,
  loboptions,
  distChannelOpts,
  addMainForm,
  handleMACheckBox,
  handleIsFranchise,
  saveModal,
  setSaveModal,
  prodtypeoptions,
  allProducerCodeList,
  loading,
}) => {
  const user = useRecoilValue(accountAtom);
  const [openModal, setOpenModal] = useState(false);
  const [addState, setAddState] = useRecoilState(prodAddState);
  const [masterCarrierIdValue, setMasterCarrierId] = useRecoilState(
    prodCodeMastercarrierId
  );
  const [selectedCarrierName, setSelectedCarrierName] =
    useRecoilState(carrierNameValue);
  const [isFranchise, setIsFranchise] = useRecoilState(prodCodeIsFranchise);
  const [isChannelFranchise, setIsChannelFranchise] = useState(
    user.isNonFranchise && user.isFranchise
      ? false
      : user.isFranchise
      ? true
      : false
  );
  const [masterAgentPrincetonId, setMasterAgentPrincetonId] = useState(0);

  const [associatedTo, setAssociatedTo] = useState([]);

  const associationValues = [
    { label: "Office", value: "Office" },
    {
      label: "Producer",
      value: "Producer",
    },
  ];

  const { data: employeeList } = useGetEmployees();
  var empFranchisesOpts = employeeList
    ?.filter(
      (x) =>
        // x.employeeId !== null &&
        // x.employeeId !== "" &&
        x.employeeTypeName === "Franchise" && x.status !== "Terminated"
    )
    ?.map((x) => {
      return {
        label: x.fullname + " - " + x.employeenumber,
        value: x.employeeId,
      };
    });
  var confieEmpOpts = employeeList
    ?.filter(
      (x) =>
        // x.employeeId !== null &&
        // x.employeeId !== "" &&
        x.employeeTypeName !== "Franchise" && x.status !== "Terminated"
    )
    ?.map((x) => {
      return {
        label: x.fullname + " - " + x.employeenumber,
        value: x.employeeId,
      };
    });
  const { data: franchiseEmp } = useFranchiseEmployee();

  const franchiseEmpOpts = franchiseEmp
    ?.filter((a) => a.isActive === "true")
    ?.map((x) => {
      return {
        label: x.firstName + " " + x.lastName,
        value: x.franchiseEmployeeId,
        managerEmployeeId: x.franchiseEmployeeId,
      };
    });

  const columns = [
    {
      name: (
        <div className="">
          Carrier: {<span className="text-red-500 ml-1 text-xs3">*</span>}
        </div>
      ),
      cellStyle: {
        width: 300,
        maxWidth: 300,
      },
      render: (row) => (
        <div
          className={`${
            row.RowId === 1 && "pb-2"
          } w-full block text-gray-700 expandedLabel fontExpand`}
        >
          {<span className="text-red-500 ml-1 text-xs3">*</span>} Carrier:
          <SelectInput
            value={
              carriers == null
                ? ""
                : carriers.filter(
                    (c) =>
                      c.value ===
                      (masterCarrierIdValue
                        ? masterCarrierIdValue
                        : row.MasterCarrierId)
                  )[0]
            }
            options={carriers}
            onChange={(selectedOptions) => {
              handleProducerCodeInputs(
                "ProducerAddressTable",
                "CarrierName",
                selectedOptions != null ? selectedOptions.value : null,
                null,
                null,
                row.RowId,
                row.producerCodeRowId == null ? 1 : row.producerCodeRowId,
                addMainForm
              );
              setSelectedCarrierName(selectedOptions?.label);
            }}
            isDisabled={addState ? addState : false}
          />
        </div>
      ),
      sortable: true,
    },
    {
      name: (
        <div className="">
          Princeton Agent Code:{" "}
          {<span className="text-red-500 ml-1 text-xs3">*</span>}
        </div>
      ),
      cellStyle: {
        width: 250,
        maxWidth: 300,
      },
      hidden: selectedCarrierName !== "National General",
      render: (row) => (
        <div className="w-full block text-gray-700 expandedLabel fontExpand">
          {/* <div className="w-full block text-gray-700 expandedLabel fontExpand">
            Princeton Agent Code:
          </div> */}
          {<span className="text-red-500 ml-1 text-xs3">*</span>}
          Princeton Agent Code:
          <TextInput
            value={row.princetonAgentCode}
            inputTextHeight={"h-7"}
            onChange={(e) => {
              handleProducerCodeInputs(
                "ProducerAddressTable",
                "princetonAgentCode",
                e.target.value,
                row.MasterCarrierId,
                null,
                row.RowId,
                row.producerCodeRowId === null ? 1 : row.producerCodeRowId,
                addMainForm
              );
            }}
            onKeyPress={(event) => {
              if (!/^[a-zA-Z0-9-]*$/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
        </div>
      ),
    },
    {
      name: <div>Master Agent Princeton ID: </div>,
      cellStyle: {
        width: 250,
        maxWidth: 300,
      },
      hidden: selectedCarrierName !== "National General",
      render: (row) => (
        <div
          className={"w-full block text-gray-700 expandedLabel fontExpand pb-2"}
        >
          <div className="">Master Agent Princeton ID:</div>

          <TextInput
            value={masterAgentPrincetonId}
            inputTextHeight={"h-7"}
            type="tel"
            onChange={(e) => {
              var princetonId = "";
              e.target.value.split("").forEach((character) => {
                if (/^[0-9]*$/.test(character)) {
                  return (princetonId = princetonId + character);
                }
              });
              setMasterAgentPrincetonId(princetonId);

              handleProducerCodeInputs(
                "ProducerAddressTable",
                "masterAgentPrincetonId",
                princetonId,
                row.MasterCarrierId,
                null,
                row.RowId,
                row.producerCodeRowId === null ? 1 : row.producerCodeRowId,
                addMainForm
              );
            }}
            onKeyPress={(event) => {
              if (!/^[0-9]*$/.test(event.key)) {
                event.preventDefault();
              }
            }}
            maxLength={15}
          />
        </div>
      ),
    },
    {
      name: (
        <div className="">
          Distribution Channel{" "}
          {<span className="text-red-500 ml-1 text-xs3"></span>}
        </div>
      ),
      cellStyle: {
        width: 300,
        maxWidth: 300,
      },
      render: (row) => (
        <div
          className={`${
            row.RowId === 1 && "pb-2"
          }  w-full block text-gray-700 expandedLabel fontExpand`}
        >
          Distribution Channel:
          {<span className="text-red-500 ml-1 text-xs3"></span>}
          <SelectInput
            value={
              // row.distChannelOpts &&
              row.distChannelOpts
                ?.map((x) => ({ label: x.label, value: x.value }))
                .filter(
                  (x) =>
                    x.value ===
                    row.ProducerCodes.map((x) => x.DistributionChannelId)[0]
                )
            }
            options={distChannelOpts}
            onChange={(selectedOptions) => {
              selectedOptions?.value === 6
                ? setIsChannelFranchise(true)
                : setIsChannelFranchise(false);
              handleProducerCodeInputs(
                tableName,
                "districhannel",
                selectedOptions ? selectedOptions.value : null,
                row.MasterCarrierId,
                null,
                row.RowId,
                row.producerCodeRowId == null ? 1 : row.producerCodeRowId,
                addMainForm
              );
            }}
          />
        </div>
      ),
    },
    {
      name: (
        <div className="">
          {<span className="text-red-500 ml-1 text-xs3">*</span>} Associated To:
        </div>
      ),
      cellStyle: {
        width: 300,
        maxWidth: 300,
      },
      render: (row) => (
        <div
          className={`${
            row.RowId === 1 && "pb-2"
          } w-full block text-gray-700 expandedLabel fontExpand`}
        >
          {<span className="text-red-500 ml-1 text-xs3">*</span>} Associated To:
          <SelectInput
            value={
              // row.associationValues &&
              associationValues.filter((x) => x.value === row.AssociatedTo)
            }
            options={associationValues}
            onChange={(selectedOptions) => {
              setAssociatedTo(selectedOptions);
              handleProducerCodeInputs(
                "ProducerAddressTable",
                "AssociatedTo",
                selectedOptions != null ? selectedOptions.value : null,
                row.MasterCarrierId,
                null,
                row.RowId,
                row.producerCodeRowId == null ? 1 : row.producerCodeRowId,
                addMainForm
              );
            }}
          />
        </div>
      ),
    },
    {
      name: (
        <div>
          Office: <span className="text-red-500">*</span>
        </div>
      ),
      cellStyle: {
        width: 300,
        maxWidth: 300,
      },
      render: (row) => (
        <div
          className={`${
            row.RowId === 1 && "pb-2"
          } w-full block font-normal text-gray-700 `}
        >
          {row.AssociatedTo === "Office" ? (
            <>
              Office:{<span className="text-red-500">*</span>}
              {user.isFranchise && user.isNonFranchise ? (
                <>
                  <SelectInput
                    value={agencies.filter(
                      (x) => x.value === row.OfficeCode + "-" + row.StoreNumber
                    )}
                    options={agencies.filter(
                      (x) =>
                        (isFranchise
                          ? x.officeType === "Franchise"
                          : x.officeType !== "Franchise") &&
                        x.officeCode !== null &&
                        x.officeCode !== ""
                    )}
                    onChange={(selectedOptions) => {
                      handleProducerCodeInputs(
                        "ProducerAddressTable",
                        "OfficeCodeStoreNumber",
                        selectedOptions ? selectedOptions.value : null,
                        row.MasterCarrierId,
                        null,
                        row.RowId,
                        row.producerCodeRowId == null
                          ? 1
                          : row.producerCodeRowId,
                        addMainForm
                      );
                    }}
                  />
                </>
              ) : (
                <>
                  <SelectInput
                    value={agencies.filter(
                      (x) => x.value === row.OfficeCode + "-" + row.StoreNumber
                    )}
                    options={agencies.filter(
                      (x) => x.officeCode !== null && x.officeCode !== ""
                    )}
                    onChange={(selectedOptions) => {
                      handleProducerCodeInputs(
                        "ProducerAddressTable",
                        "OfficeCodeStoreNumber",
                        selectedOptions ? selectedOptions.value : null,
                        row.MasterCarrierId,
                        null,
                        row.RowId,
                        row.producerCodeRowId == null
                          ? 1
                          : row.producerCodeRowId,
                        addMainForm
                      );
                    }}
                  />
                </>
              )}
            </>
          ) : row.AssociatedTo === "Producer" ? (
            <>
              Producer:{<span className="text-red-500">*</span>}
              {user.isFranchise && user.isNonFranchise ? (
                <>
                  <SelectInput
                    value={
                      isChannelFranchise
                        ? empFranchisesOpts?.filter(
                            (x) => x.value === row.Producer
                          )
                        : confieEmpOpts?.filter((x) => x.value === row.Producer)
                    }
                    options={
                      isChannelFranchise ? empFranchisesOpts : confieEmpOpts
                    }
                    onChange={(selectedOptions) => {
                      handleProducerCodeInputs(
                        "ProducerAddressTable",
                        "Producer",
                        selectedOptions !== null ? selectedOptions.value : null,
                        row.MasterCarrierId,
                        null,
                        row.RowId,
                        row.producerCodeRowId == null
                          ? 1
                          : row.producerCodeRowId,
                        addMainForm
                      );
                    }}
                  />
                </>
              ) : (
                <>
                  <SelectInput
                    value={
                      isChannelFranchise
                        ? empFranchisesOpts?.filter(
                            (x) => x.value === row.Producer
                          )
                        : confieEmpOpts?.filter((x) => x.value === row.Producer)
                    }
                    options={
                      isChannelFranchise ? empFranchisesOpts : confieEmpOpts
                    }
                    onChange={(selectedOptions) => {
                      handleProducerCodeInputs(
                        "ProducerAddressTable",
                        "Producer",
                        selectedOptions !== null ? selectedOptions.value : null,
                        row.MasterCarrierId,
                        null,
                        row.RowId,
                        row.producerCodeRowId == null
                          ? 1
                          : row.producerCodeRowId,
                        addMainForm
                      );
                    }}
                  />
                </>
              )}
            </>
          ) : (
            <>
              {" "}
              <div className="text-xs text-secondary italic font-normal mb-1">
                <b> Note:</b> Select in Associated To field first.
              </div>
              <SelectInput isDisabled={true} />
            </>
          )}
        </div>
      ),
    },
    // {
    //   name: (
    //     <div className="">
    //       Princeton Agent Code:{" "}
    //       {<span className="text-red-500 ml-1 text-xs3">*</span>}
    //     </div>
    //   ),
    //   cellStyle: {
    //     width: 250,
    //     maxWidth: 300,
    //   },
    //   hidden: selectedCarrierName !== "National General",
    //   render: (row) => (
    //     <div className="w-full block text-gray-700 expandedLabel fontExpand">
    //       {/* <div className="w-full block text-gray-700 expandedLabel fontExpand">
    //         Princeton Agent Code:
    //       </div> */}
    //       {<span className="text-red-500 ml-1 text-xs3">*</span>}
    //       Princeton Agent Code:
    //       <TextInput
    //         value={row.masterAgentPrincetonId}
    //         inputTextHeight={"h-7"}
    //         onChange={(e) => {
    //           handleProducerCodeInputs(
    //             "ProducerAddressTable",
    //             "princetonAgentCode",
    //             e.target.value,
    //             row.MasterCarrierId,
    //             null,
    //             row.RowId,
    //             row.producerCodeRowId === null ? 1 : row.producerCodeRowId,
    //             addMainForm
    //           );
    //         }}
    //         onKeyPress={(event) => {
    //           if (!/^[a-zA-Z0-9-]*$/.test(event.key)) {
    //             event.preventDefault();
    //           }
    //         }}
    //       />
    //     </div>
    //   ),
    // },
    // {
    //   name: <div>Master Agent Princeton ID: </div>,
    //   cellStyle: {
    //     width: 250,
    //     maxWidth: 300,
    //   },
    //   hidden: selectedCarrierName !== "National General",
    //   render: (row) => (
    //     <div
    //       className={"w-full block text-gray-700 expandedLabel fontExpand pb-2"}
    //     >
    //       <div className="">Master Agent Princeton ID:</div>

    //       <TextInput
    //         value={row.princetonAgentCode}
    //         inputTextHeight={"h-7"}
    //         type="tel"
    //         onChange={(e) => {
    //           handleProducerCodeInputs(
    //             "ProducerAddressTable",
    //             "masterAgentPrincetonId",
    //             e.target.value,
    //             row.MasterCarrierId,
    //             null,
    //             row.RowId,
    //             row.producerCodeRowId === null ? 1 : row.producerCodeRowId,
    //             addMainForm
    //           );
    //         }}
    //         onKeyPress={(event) => {
    //           if (!/^[0-9]*$/.test(event.key)) {
    //             event.preventDefault();
    //           }
    //         }}
    //         maxLength={15}
    //       />
    //     </div>
    //   ),
    // },
  ];
  const emptyRow = [{ Address: "", City: "", ProducerCodes: "" }];

  return (
    <div className="mt-4 mb-2">
      <MaterialSubTable
        data={
          carrierProducerCodeData
            ? carrierProducerCodeData.map((d, i) => ({
                ...d,
                tableData: {
                  showDetailPanel: (row) => (
                    <ProdCodeFormProducerCodeSection
                      tableName={tableName}
                      prodtypeoptions={prodtypeoptions}
                      handleContactInputs={handleContactInputs}
                      handleAddProducerCodeRow={handleAddProducerCodeRow}
                      handleRemoveProducerCodeRow={handleRemoveProducerCodeRow}
                      handleProducerCodeInputs={handleProducerCodeInputs}
                      carrierProducerCodeData={
                        carrierProducerCodeData[parseInt(row.RowId) - 1]
                      }
                      rowIsClearDropdowns={row.IsRemoveDropdowns}
                      isResetCarrierDependency={row.IsResetCarrierDependency}
                      rowIsFranchise={row.IsFranchise}
                      masterCarrierId={data == null ? "" : data.masterCarrierId}
                      state={data == null ? "" : data.state}
                      rowId={row.RowId}
                      loboptions={loboptions}
                      distChannelOpts={distChannelOpts}
                      addMainForm={addMainForm}
                      handleMACheckBox={handleMACheckBox}
                      handleIsFranchise={handleIsFranchise}
                      saveModal={saveModal}
                      setSaveModal={setSaveModal}
                      employeeOpts={employeeList}
                      employeeFranchiseOpts={franchiseEmpOpts}
                      empFranchisesOpts={empFranchisesOpts}
                      empConfieOpts={confieEmpOpts}
                      isChannelFranchise={isChannelFranchise}
                      agencies={agencies}
                      allProducerCodeList={allProducerCodeList}
                    />
                  ),
                },
              })) || []
            : emptyRow
        }
        columns={columns}
        loading={loading}
      />
    </div>
  );
};

export default ProdCodeFormCarrierSection;
